let dbready = false;
/**
 * @type {IDBDatabase}
 */
let DB = null;
export const FILES_STORE_NAME = "Files";
export const SURVEY_STORE_NAME = "SurveyInstances";
export const TICKETS_STORE_NAME = "Tickets";

const VERSION = parseFloat(2.0).toFixed(2);
export const DB_NAME = "MSM_LOOPDB";
/**
 * @param {string} name - The name of the db
 * @param {number} version - The version of the DB,lower versions will get rejected
 * @returns {IDBOpenDBRequest} The potential connection to the db
 */
async function getDb(name, version) {
  return new Promise((resolve, reject) => {
    let request = window.indexedDB.open(name, version);

    request.onerror = (e) => {
      console.error("Error opening db", e);
      reject(e);
    };

    request.onsuccess = (e) => {
      resolve(e.target.result);
    };
    // Modify the Schema here
    request.onupgradeneeded = (e) => {
      console.error("DB version upgrade");

      DB = e.target.result;
      let objectStore1 = DB.createObjectStore(SURVEY_STORE_NAME, {
        autoIncrement: false,
        keyPath: "SurveyInstanceId",
      });
      let tickets = DB.createObjectStore(TICKETS_STORE_NAME, {
        autoIncrement: false,
        keyPath: "SurveyInstanceId",
      });

      let filestore = DB.createObjectStore(FILES_STORE_NAME, {
        autoIncrement: false,
        keyPath: "GUID",
      });
    };
  });
}

/**
 * Setup the internal Browser DB and set a flag if succesfull
 */
export async function setupIndexDB() {
  if (!window.indexedDB) {
    console.error(
      "Your browser doesn't support a stable version of IndexedDB. Offline Saving features will not be available."
    );
    throw TypeError("IndexDB is not defined");
  }
  try {
    DB = await getDb(DB_NAME, 1);
    dbready = true;
  } catch (error) {
    dbready = false;
    throw Error(error);
  }
}
/**
 *
 * @param {String} store The store you wish to search
 * @param {*} key the key to the obj
 * @returns {Promise<Boolean>}
 */
export async function storeHas(store, key) {
  if (!dbready) {
    await setupIndexDB().catch((err) => {
      console.error("Error in addFiletoDb", err);
    });
  }

  return new Promise((resolve, reject) => {
    // Start a database transaction and get the object store
    let trans = DB.transaction(store, "readonly");
    let objstore = trans.objectStore(store);
    // count the objects
    let req = objstore.get(key);
    trans.oncomplete = (e) => {
      if (req.result === undefined) {
        resolve(false);
      } else {
        resolve(true);
      }
    };
    trans.onerror = (err) => {
      reject(err);
    };
  });
}

/**
 *
 * @param {File} file -the File to Upload
 * @param {*} GUID -The key for the db
 * @returns
 */
export async function addFiletoDB(file, GUID) {
  if (!dbready) {
    await setupIndexDB().catch((err) => {
      console.error("Error in addFiletoDb", err);
    });
  }

  let reader = new FileReader();
  reader.readAsDataURL(file);
  let filegeobj = {
    GUID,
    file,
  };
  reader.onload = (e) => {
    filegeobj.file = e.target.result;
  };

  return new Promise((resolve, reject) => {
    // Start a database transaction and get the files object store
    let trans = DB.transaction(FILES_STORE_NAME, "readwrite");
    let store = trans.objectStore(FILES_STORE_NAME);
    // put the file in store
    store.put(filegeobj);

    trans.oncomplete = (e) => {
      resolve(GUID);
    };
    trans.onerror = (err) => {
      reject(err);
    };
  });
}
/**
 * @param {string} id The Id of the the file
 * @returns {Promise<File>} The File if found
 */
export async function getFilefromDB_byID(id) {
  if (!dbready) {
    await setupIndexDB().catch((err) => {
      console.error("Error in getFilefromDB_byID", err);
    });
  }
  return new Promise((resolve, reject) => {
    let trans = DB.transaction([FILES_STORE_NAME], "readonly");
    let result;
    trans.oncomplete = (e) => {
      if (result && result.file) {
        resolve(result.file);
      } else {
        reject(`obj with key:${id} not found in DB`);
      }
    };
    trans.onerror = (err) => reject(err);

    let store = trans.objectStore(FILES_STORE_NAME);
    let getreq = store.get(id);
    getreq.onsuccess = () => {
      result = getreq.result;
    };
  });
}
/**
 * @param {string} id The Id of the the file
 * @returns {Promise<File>} The File if found
 */
export async function clearFileStore() {
  if (!dbready) {
    await setupIndexDB().catch((err) => {
      console.error("Error in getFilefromDB_byID", err);
    });
  }
  return new Promise((resolve, reject) => {
    let trans = DB.transaction([FILES_STORE_NAME], "readwrite");
    trans.oncomplete = (e) => {
      resolve();
    };
    trans.onerror = (err) => reject(err);

    let store = trans.objectStore(FILES_STORE_NAME);
    let clearReq = store.clear();
    clearReq.onsuccess = () => {
      console.debug(FILES_STORE_NAME + " cleared");
    };
  });
}

export async function currentDB() {
  if (!dbready) {
    try {
      await setupIndexDB();
    } catch (err) {
      console.error("Error in getFilefromDB_byID", err);
    }
  }
  return DB;
}



// WEBPACK FOOTER //
// ./src/services/IndexDB/index.js